import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Card/CardBody.js",
    _this = this;

import { BodyText, BodyWrapper, ViewMoreText, ViewMoreWrapper } from './style';
import React, { useState } from 'react';
import MultilineTruncateParagraph from '../../core/components/MultilineTruncateParagraph';
import { useTheme } from '../../core/ThemeProvider';
import { ArrowDown, ArrowUp } from '@dls/assets/icons';

var CardBody = function CardBody(_ref) {
  var children = _ref.children;

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      truncated = _useState2[0],
      setTruncated = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isOverFlow = _useState4[0],
      setOverflow = _useState4[1];

  var _useTheme = useTheme(),
      theme = _useTheme.theme;

  return /*#__PURE__*/React.createElement(BodyWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(MultilineTruncateParagraph, {
    Typography: BodyText,
    numOfLines: 3,
    truncated: truncated,
    onChangeOverflow: setOverflow,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 7
    }
  }, children), isOverFlow && /*#__PURE__*/React.createElement(ViewMoreWrapper, {
    onClick: function onClick() {
      return setTruncated(!truncated);
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(ViewMoreText, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 11
    }
  }, "View ", truncated ? 'More' : 'Less'), truncated ? /*#__PURE__*/React.createElement(ArrowDown, {
    size: 16,
    color: theme.cl_sec_d1,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 13
    }
  }) : /*#__PURE__*/React.createElement(ArrowUp, {
    size: 16,
    color: theme.cl_sec_d1,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 13
    }
  })));
};

export default CardBody;